















































































































import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import Plyr from "plyr";
import "plyr/dist/plyr.css";

@Component
export default class DynamicVideo extends Vue {
    @Prop() image?: string;

    @Prop() videoUrl?: string;

    @Ref() readonly plyr!: HTMLElement;

    ready: boolean = false;

    mounted() {
        if (this.plyr) {
            const player = new Plyr(this.plyr, {
                volume: 0.4,
                hideControls: false
            });

            player.toggleControls(false);

            if (this.image) player.poster = this.image;

            player.on("play", event => {
                player.toggleControls(true);
            });

            // Added a small delay before flagging the video as ready in order to prevent the controls from flickering
            setTimeout(() => {
                this.ready = true;
            }, 1000);
        }
    }

    get vimeoId() {
        const urlParts = this.videoUrl?.split("/");
        if (urlParts) {
            return urlParts[urlParts.length - 1];
        }
        return "";
    }

    get youtubeId() {
        if (this.videoUrl) {
            var url = new URL(this.videoUrl);

            if (url.pathname.includes("/embed/")) {
                return url.pathname.split("/embed/")[1];
            }

            return url.searchParams.get("v");
        }

        return "";
    }
}
